import React, { useState } from 'react';
import apiClient from '../api/client';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Alert } from './ui/alert';



function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await apiClient.post(`/auth/forgot-password`, { email });
      setMessage('Reset link sent to your email if it exists.');
      setError('');
    } catch (err) {
      setError('Error sending reset link.');
      setMessage('');
    }
  };

  return (
    <Card className="w-full max-w-md mx-auto mt-20">
      <CardHeader>
        <CardTitle>Forgot Password</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          {error && <Alert variant="destructive">{error}</Alert>}
          {message && <Alert>{message}</Alert>}
          <Button type="submit" className="w-full">Send Reset Link</Button>
        </form>
      </CardContent>
    </Card>
  );
}

export default ForgotPassword;